/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Size_Default_KgInputs */

const vi_lot_size_default_kg = /** @type {(inputs: Lot_Size_Default_KgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khối lượng mặc định (kg)`)
};

/**

* @param {Lot_Size_Default_KgInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_size_default_kg = /** @type {((inputs?: Lot_Size_Default_KgInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Size_Default_KgInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_size_default_kg(inputs)
});